import React from 'react'
import { initializeQuoraTracking, trackQuoraEvent } from '../utils/tracking';

const useQuora = (email) => {
  React.useEffect(() => {
    initializeQuoraTracking(email);
  }, [email]);
  
  return React.useCallback((title = 'Purchase', data) => {
    trackQuoraEvent(title, data, email);
  }, [email]);
}

export default useQuora;
